import type { Dayjs } from 'dayjs';
import { chunk, concat, fill, range } from 'lodash-es';

const WEEK_COUNT = 7;

export default class Calendar {
  private readonly time: Dayjs;
  private monthRange: (number | null)[];

  constructor(time: Dayjs) {
    this.time = time;
    this.monthRange = this.makeMonthRange();
  }

  private makeArrayOfEmpty(count: number) {
    return fill(range(count), null);
  }

  private makeMonthRange() {
    const start = this.time.startOf('month');
    const end = this.time.endOf('month');
    const numberOfStartDay = start.get('day'); // 0 - 6
    const numberOfEndDay = end.get('day'); // 0 - 6

    const emptyDayBeforeFirstdayOfMonth = this.makeArrayOfEmpty(numberOfStartDay);
    const emptyDayAfterLastdayOfMonth = this.makeArrayOfEmpty(WEEK_COUNT - numberOfEndDay - 1);

    const monthRange = range(start.date(), end.date() + 1);

    return concat(emptyDayBeforeFirstdayOfMonth, monthRange, emptyDayAfterLastdayOfMonth);
  }

  /**
   * 아래와 같은 형태의 날짜 matrix를 제공함
   * @example
   * [
      [null, null, null, 1, 2, 3, 4],
      [5, 6, 7, 8, 9, 10, 11],
      [12, 13, 14, 15, 16, 17, 18],
      [19, 20, 21, 22, 23, 24, 25],
      [26, 27, 28, 29, 30, 31, null],
    ];
   */
  public getMonthMatrix() {
    return chunk(this.monthRange, WEEK_COUNT);
  }

  public getLastWeekIndex() {
    return this.getMonthMatrix().length - 1;
  }
}
